export default {
  LNSSTextBasedPersonalizer: 'LNSSTextBasedPersonalizer'
};
